import Feedable from '@/global/dejaVue/feedable'
import { ChargeViewModelVisitorInterface } from '../services/ChargeViewModelVisitorinterface'
import Vue from 'vue'
import {
  ChargeLighting,
  ChargeBatteryCharger,
  ChargeOfficeEquipement,
  ChargeMiscLinear,
  ChargeMiscNonLinear,
  ChargeUPS,
  ChargeMedicalEquipement,
  ChargeWelder,
  ChargeMotor,
  ChargeAirConditionner,
  ChargeFirePump,
  ChargeElevator,
  ChargeATS,
  ChargeTransformer,
  ChargeCircuitBreaker,
  ChargeModel,
  Harmonics,
  ChargeGenerator
} from './chargeModel'
import { ChargeOutput } from './ChargeOutput'
import TypeCharge from './typeCharge'
import { VisitableChargeViewModel } from '../services/VisitableChargeViewModel'
import { ChargeState } from '@/modules/project/components/loads/models/ChargeState'

/* ================= PARTIE QUI SERT A L'AFFICHAGE DU FORMULAIRE  ================= */
/** Defini la totalité des champs du formulaire dans le ChargeOutput */

export class PatronFormulaireModel extends Feedable {
  public isLeaf = false
  public step = false
  public description = false
  public qt = false
  public unit = false
  public units3Phases = new Array<string>()
  public units1Phase = new Array<string>()
  public powerAmpsValue = false
  public idVoltage = false
  public idLoadConnection = false
  public startingAmps = false
  public numberOfPhases = false
  public idLightingType = false
  public idBallast = false
  public application = false
  public idBatteryType = false
  public numberOfComputer = false
  public numberOfPrinter = false
  public numberOfFax = false
  public numberOfCopiers = false
  public haveInputFilter = false
  public currentCharge = false
  public runningPF = false
  public rectifierType = false
  public outputRating = false
  public loading = false
  public batteryChargerPercentage = false
  public maxVoltageDip = false
  public maxPeakKVA = false
  public pFAtMaxPeakKVA = false
  public continuousKVA = false
  public continuousPF = false
  public runningKVA = false
  public peakKVA = false
  public idWelderSpec = false // AC / DC
  public idMotorCodeLetter = false
  public idMotorStartingMethod = false
  public startingMethods = new Array<string>()
  public idMotorVFDType = false
  public isVoltageDipLock = false
  public typesVFD = new Array<string>()
  public idMotorSinglePhaseType = false
  public motorCaracs = new Array<string>()
  public sCCL = false
  public design = true // NEMA / IEC
  public isLoaded = true // isLoaded / unloaded
  public amps = false
  public kVARating = false
  public idPrimaryVoltage = false
  public idSecondaryVoltage = false
  public percentageRating = false
  public haveRegenerativeDrive = false
  public regenerativeDrivePercent = false
  public isOff = false // on / off
  public isNECRequirement = false
  public startingPower = false
  public startingPF = false
  public ithd = false
  public loadFactor = false
  public vFDSkVaLimit = false
  public vFDEfficiency = false
  public motorEfficiency = false
  public efficiency = false
  public numberOfCompressor = false
  public tonHeating = false
  public sEER = false
  public harmonics = false
  public calculation = false // calcul effectué par le front

  constructor(options?: Partial<PatronFormulaireModel>) {
    super()
    this.feed(options, true)
  }
}
class LightingPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['kW', 'kVA', 'Amps']
  units3Phases = ['kW', 'kVA', 'Amps']
  powerAmpsValue = true
  idLightingType = true
  idBallast = true
  haveInputFilter = true
  runningPF = true
  startingPF = true
  ithd = true
  loadFactor = true
  harmonics = true
  calculation = true
}
class BatteryChargerPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['kW', 'kVA', 'Amps', 'DC Voltage']
  units3Phases = ['kW', 'kVA', 'Amps', 'DC Voltage']
  powerAmpsValue = true
  idBatteryType = true
  idTypeRectifier = true
  haveInputFilter = true
  currentCharge = true
  runningPF = true
  startingPF = true
  ithd = true
  harmonics = true
  calculation = true
}
class OfficeEquipementPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  numberOfComputer = true
  numberOfPrinter = true
  numberOfFax = true
  numberOfCopiers = true
  runningPF = true
  startingPF = true
  ithd = true
  harmonics = true
  calculation = true
}
class MiscLinearPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['kW', 'kVA', 'Amps']
  units3Phases = ['kW', 'kVA', 'Amps']
  powerAmpsValue = true
  isOff = true
  startingPower = true
  runningPF = false
  startingPF = true
  loadFactor = true
  calculation = true
}
class MiscNonLinearPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['kW', 'kVA', 'Amps']
  units3Phases = ['kW', 'kVA', 'Amps']
  powerAmpsValue = true
  haveInputFilter = true
  idUpsType = true
  isOff = true
  runningPF = false
  startingPower = true
  startingPF = true
  ithd = true
  loadFactor = true
  harmonics = true
  calculation = true
}
class UPSPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  haveInputFilter = true
  idUpsType = true // old rectifier type
  outputRating = true
  loading = true
  batteryChargerPercentage = true
  runningPF = true
  startingPF = true
  ithd = true
  efficiency = true
  harmonics = true
  calculation = true
}
class MedicalEquipementPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  maxVoltageDip = true
  maxPeakKVA = true
  pFAtMaxPeakKVA = true
  continuousKVA = true
  continuousPF = true
  isOff = true
  calculation = true
}
class WelderPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  isOff = true
  haveInputFilter = true
  idWelderSpec = true
  runningKVA = true
  peakKVA = true
  runningPF = true
  startingPF = true
  ithd = true
  loadFactor = true
  harmonics = true
  calculation = true
}
class MotorPatron extends PatronFormulaireModel {
  units1Phase = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  units3Phases = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  powerAmpsValue = true
  startingAmps = true
  numberOfPhases = true
  haveInputFilter = true
  idMotorCodeLetter = true
  idMotorStartingMethod = true
  idMotorVFDType = true
  idMotorSinglePhaseType = true
  sCCL = true
  design = true
  isLoaded = true
  isOff = true
  runningPF = true
  startingPF = true
  motorEfficiency = true
  ithd = true
  loadFactor = true
  vFDSkVaLimit = true
  vFDEfficiency = true
  harmonics = true
  calculation = true
}
class AirConditionnerPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['Tons', 'Btu HR', 'Amps']
  units3Phases = ['Tons', 'Btu HR', 'Amps']
  powerAmpsValue = true
  startingAmps = true
  numberOfPhases = true
  haveInputFilter = true
  idMotorCodeLetter = true
  idMotorStartingMethod = true
  idMotorVFDType = true
  idMotorSinglePhaseType = true
  sCCL = true
  design = true
  isLoaded = true
  isOff = true
  efficiency = true
  vFDSkVaLimit = true
  vFDEfficiency = true
  ithd = true
  runningPF = true
  startingPF = true
  numberOfCompressor = true
  tonHeating = true
  sEER = true
  harmonics = true
  calculation = true
}
class FirePumpPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true
  idVoltage = true
  unit = true
  units1Phase = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  units3Phases = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  powerAmpsValue = true
  startingAmps = true
  numberOfPhases = true
  haveInputFilter = true
  idMotorCodeLetter = true
  idMotorStartingMethod = true
  idMotorSinglePhaseType = true
  isVoltageDipLock = true
  sCCL = true
  idMotorVFDType = true
  design = true
  isLoaded = true
  isOff = true
  isNECRequirement = true
  motorEfficiency = true
  vFDSkVaLimit = true
  vFDEfficiency = true
  ithd = true
  runningPF = true
  startingPF = true
  loadFactor = true
  harmonics = true
  calculation = true
}
class ElevatorPatron extends PatronFormulaireModel {
  step = true
  description = true
  qt = true
  idLoadConnection = true // Condition de filtre - true si generator phase == 3
  idVoltage = true
  unit = true
  units1Phase = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  units3Phases = ['kVA', 'HP', 'Amps', 'kWe', 'kWm']
  powerAmpsValue = true
  startingAmps = true // if unit == "amps"
  numberOfPhases = true //disabled if generator phase == 1 // phase
  haveInputFilter = true
  idMotorCodeLetter = true
  idMotorStartingMethod = true
  idMotorVFDType = true
  idMotorSinglePhaseType = true
  sCCL = true
  design = true
  isLoaded = true
  isOff = true
  ithd = true
  motorEfficiency = true
  vFDSkVaLimit = true
  vFDEfficiency = true
  haveRegenerativeDrive = true
  regenerativeDrivePercentage = true
  runningPF = true
  startingPF = true
  loadFactor = true
  harmonics = true
  calculation = true
}
class ATSPatron extends PatronFormulaireModel {
  description = true
  amps = true
}
class TransformerPatron extends PatronFormulaireModel {
  description = true
  kVARating = true
  idPrimaryVoltage = true
  idSecondaryVoltage = true
}
class CircuitBreakerPatron extends PatronFormulaireModel {
  description = true
  amps = true
  percentageRating = true
}

export class ChargeViewModel extends Feedable
  implements VisitableChargeViewModel {
  public id = 0
  public nom = ''
  public state = ChargeState.UPDATED
  public isLeaf = false
  public model = new ChargeModel()
  public patron = new PatronFormulaireModel()
  public children = new Array<ChargeViewModel>()

  // Harmonique issu du remplissage via le référentiel lorsque saisi (exemple BallastDriver sur une lighting type)
  public baseHarmonics = new Harmonics()

  constructor(options?: Partial<ChargeViewModel>) {
    super()
    this.feed(options)
  }
  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    //throw new Error("Unimplemented")
    return new Object()
  }
  copyType() {
    return new ChargeViewModel()
  }
  getChildren() {
    const loads = this.children.map(x => new ChargeViewModel(x))
    if (this.children.length > 0) {
      this.children.forEach(x => {
        loads.push(...x.getChildren())
      })
    }
    return loads
  }
}

export class ChargeLightingViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Lighting
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.typeLighting.loadName
  isLeaf = true
  model = new ChargeLighting()
  patron = new LightingPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitLighting(this)
  }

  copyType() {
    return new ChargeLightingViewModel()
  }
}
export class ChargeBatteryChargerViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.BatteryCharger
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.batteryCharger.loadName
  isLeaf = true
  model = new ChargeBatteryCharger()
  patron = new BatteryChargerPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitBatteryCharger(this)
  }
  copyType() {
    return new ChargeBatteryChargerViewModel()
  }
}
export class ChargeOfficeEquipementViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.OfficeEquipement
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.officeEquipement.loadName
  isLeaf = true
  model = new ChargeOfficeEquipement()
  patron = new OfficeEquipementPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitOfficeEquipment(this)
  }
  copyType() {
    return new ChargeOfficeEquipementViewModel()
  }
}
export class ChargeMiscLinearViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.LinearLoad
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.linearLoad.loadName
  isLeaf = true
  model = new ChargeMiscLinear()
  patron = new MiscLinearPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitMiscLinear(this)
  }
  copyType() {
    return new ChargeMiscLinearViewModel()
  }
}
export class ChargeMiscNonLinearViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.NoLinearLoad
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.noLinearLoad.loadName
  isLeaf = true
  model = new ChargeMiscNonLinear()
  patron = new MiscNonLinearPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitNonMiscLinear(this)
  }
  copyType() {
    return new ChargeMiscNonLinearViewModel()
  }
}
export class ChargeUPSViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.UPS
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.ups.loadName
  isLeaf = true
  model = new ChargeUPS()
  patron = new UPSPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitUPS(this)
  }
  copyType() {
    return new ChargeUPSViewModel()
  }
}
export class ChargeMedicalEquipementViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.MedicalEquipment
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.medicalEquipment.loadName
  isLeaf = true
  model = new ChargeMedicalEquipement()
  patron = new MedicalEquipementPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitMedicalEquipment(this)
  }
  copyType() {
    return new ChargeMedicalEquipementViewModel()
  }
}
export class ChargeWelderViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Welder
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.welder.loadName
  isLeaf = true
  model = new ChargeWelder()
  patron = new WelderPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitWelder(this)
  }
  copyType() {
    return new ChargeWelderViewModel()
  }
}
export class ChargeMotorViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Motor
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.motor.loadName
  isLeaf = true
  model = new ChargeMotor()
  patron = new MotorPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitMotor(this)
  }
  copyType() {
    return new ChargeMotorViewModel()
  }
}
export class ChargeAirConditionnerViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.AirConditioner
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.airConditioner.loadName
  isLeaf = true
  model = new ChargeAirConditionner()
  patron = new AirConditionnerPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitAirConditionner(this)
  }
  copyType() {
    return new ChargeAirConditionnerViewModel()
  }
}
export class ChargeFirePumpViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.FirePump
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.firePump.loadName
  isLeaf = true
  model = new ChargeFirePump()
  patron = new FirePumpPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitFirePump(this)
  }
  copyType() {
    return new ChargeFirePumpViewModel()
  }
}
export class ChargeElevatorViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Elevator
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.elevator.loadName
  isLeaf = true
  model = new ChargeElevator()
  patron = new ElevatorPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitElevator(this)
  }
  copyType() {
    return new ChargeElevatorViewModel()
  }
}
export class ChargeATSViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.ATS
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.ats.loadName
  isLeaf = false
  model = new ChargeATS()
  patron = new ATSPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitATS(this)
  }
  copyType() {
    return new ChargeATSViewModel()
  }
}
export class ChargeTransformerViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Transformer
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.transformer.loadName
  isLeaf = false
  model = new ChargeTransformer()
  patron = new TransformerPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitTransformer(this)
  }
  copyType() {
    return new ChargeTransformerViewModel()
  }
}
export class ChargeCircuitBreakerViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.CircuitBreaker
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.circuitBreaker.loadName
  isLeaf = false
  model = new ChargeCircuitBreaker()
  patron = new CircuitBreakerPatron()

  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitCircuitBreaker(this)
  }
  copyType() {
    return new ChargeCircuitBreakerViewModel()
  }
}
export class ChargeGeneratorViewModel extends ChargeViewModel
  implements VisitableChargeViewModel {
  id = TypeCharge.Generator
  nom =
    Vue.prototype.$translator.language.data.modules.project.projectMenu
      .loadProfile.generator.loadName
  isLeaf = false
  model = new ChargeGenerator()
  accept(visitor: ChargeViewModelVisitorInterface): ChargeOutput {
    return visitor.visitGenerator(this)
  }
  copyType() {
    return new ChargeGeneratorViewModel()
  }
}
